import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import { UserDetailsApi, M_UserDetailsApi, CreateBookingApi } from "../services/Api";
import { isAuthenticated } from "../services/Auth";
import { Navigate } from "react-router-dom";

export default function BookingSlot({ bookingSlotItems, setBookingSlotItems }) {
    const [complete, setComplete] = useState(false);
    const [user, setUser] = useState({ fullName: "", email: "", pno: "", address: "", localId: "" });
    const order = { user: user, bookingSlotItems: bookingSlotItems };


    useEffect(() => {
        if (isAuthenticated()) {
            UserDetailsApi().then((response) => {
                setUser(values => ({
                    ...values,
                    localId: response.data.users[0].localId
                }))
            })
        }
    }, [])

    useEffect(() => {
        if (isAuthenticated() && user.localId) {
            M_UserDetailsApi(user.localId).then((response) => {
                setUser(values => ({
                    ...values,
                    fullName: response.data.user[0].fullName,
                    email: response.data.user[0].email,
                    pno: response.data.user[0].pno,
                    address: response.data.user[0].address
                }));
            })
        }
    }, [user.localId])

    function increaseQty(item) {
        if (item.room.vacancies <= item.qty) {
            return;
        }
        const updatedItems = bookingSlotItems.map((i) => {
            if (i.room._id === item.room._id) {
                i.qty++
            }
            return i;
        })
        setBookingSlotItems(updatedItems)
    }

    function updateDays(days, item) {

        const updatedItems = bookingSlotItems.map((i) => {
            if (i.room._id === item.room._id) {
                i.days = days;
            }
            return i;
        })
        setBookingSlotItems(updatedItems)
    }

    function decreaseQty(item) {
        if (item.qty > 1) {
            const updatedItems = bookingSlotItems.map((i) => {
                if (i.room._id === item.room._id) {
                    i.qty--
                }
                return i;
            })
            setBookingSlotItems(updatedItems)
        }
    }

    function removeItem(item) {
        const updatedItems = bookingSlotItems.filter((i) => {
            if (i.room._id !== item.room._id) {
                return true;
            }
            return false;
        })
        setBookingSlotItems(updatedItems);
        toast.success("Item Removed");
    }



    function placeBookingHandler() {
        try {
            CreateBookingApi(order);
            setBookingSlotItems([]);
            toast.success("Booking Success!");
        } catch (err) {
            console.log(err)
        } finally {
            setComplete(true);
        }
    }

    if (!isAuthenticated()) {
        //redirect user to login
        return <Navigate to="/login" />
    }

    return bookingSlotItems.length > 0 ? <>
        <div className="container-fluid p-3">
            <div className="row">
                <h2 className="mt-5 text-center">Your Booking Slot: <b>{bookingSlotItems.length} Varient Room(s)</b></h2>
                <div className="col-12 col-lg-9">
                    {bookingSlotItems.map((item) =>
                    (<div key={item.room._id}>
                        <hr />
                        <div className="bookingSlot-item">
                            <div className="row">
                                <div className="col-6 col-lg-3 text-center">
                                    <Link to={"/room/" + item.room._id}>
                                    <img src={item.room.images[0].image} alt={item.room.name} height="110" width="140" />
                                    </Link>
                                </div>

                                <div className='col-6 col-lg-9'>
                                    <div className="row d-flex flex-column flex-lg-row justify-content-center align-items-center">
                                        <h6 className="col text-center m-2">
                                            <Link className='text-black' to={"/room/" + item.room._id} >{item.room.name}</Link>
                                        </h6>

                                        <div className="col text-center m-2">
                                            <div>
                                                <label className='form-label h6' htmlFor="days">Days</label>
                                                <div className='d-flex justify-content-center'>
                                                    <input className='form-control text-center w-50' type="number" id='days' name='days' min={1} max={365} value={item.days} onChange={(e) => updateDays(e.target.value, item)} />
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col text-center m-2">
                                            <h6>Rooms</h6>
                                            <div className="d-flex justify-content-evenly">
                                                <span className="btn btn-danger" onClick={() => decreaseQty(item)}>-</span>
                                                <input type="number" className="text-center w-25" name="qty" value={item.qty} readOnly />

                                                <span className="btn btn-primary" onClick={() => increaseQty(item)}>+</span>
                                            </div>
                                        </div>

                                        <div className="col text-center m-3">
                                            <h5>Rs. {item.room.price * item.days * item.qty}</h5>
                                            <span onClick={() => removeItem(item)}><i className="fa fa-trash btn btn-danger"></i></span>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>)
                    )}

                </div>

                <div className="col-12 col-lg-3 my-5 text-center">
                    <div className='border rounded-5 p-5'>
                        <h4>Booking Summary</h4>
                        <hr />
                        <h6 className='m-4'>Subtotal:  <span className='text-danger'>{bookingSlotItems.reduce((acc, item) => (acc + item.qty), 0)} (Rooms)</span></h6>
                        <h6 className='m-4'>Est. total: <span className='text-danger'>Rs. {Number(bookingSlotItems.reduce((acc, item) => (acc + item.room.price * item.qty * item.days), 0)).toFixed(2)}</span></h6>

                        <hr />
                        <button onClick={placeBookingHandler} className="btn btn-success">Place Booking</button>
                    </div>
                </div>
            </div>
        </div>
    </> : (!complete ? <h2 className='m-5 p-5 text-center'>Your Booking Slot is Empty!</h2>
        : <div className='m-5 p-5 text-center'>
            <h2>Booking Complete!</h2>
            <p>Your order has been placed succesfully.</p>
        </div>)
}